import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

function PositionDetails() {
  const { position } = useParams();

  const positionData = {
    'full-stack-engineer': {
      title: 'Full Stack Team Lead – E-commerce Applications',
      department: 'Engineering',
      location: 'Full Remote',
      about: 'SellAbroad empowers international e-commerce brands to expand into the MENA market by streamlining cross-border logistics, integrating local payment methods, and leveraging AI sales tools. We build robust, scalable, and secure e-commerce applications that drive global success.',
      description: 'We are seeking a highly skilled Fullstack Team Lead to join our innovative team. In this role, you will be responsible for leading and managing a team of developers while driving both frontend and backend development. You will design responsive user interfaces using JavaScript, React, Tailwind CSS, and TypeScript, and develop robust backend services with Node.js. You will work in an agile environment, overseeing the development of microservices-based architectures that power our platform.',
      responsibilities: [
        'Provide technical guidance and mentorship to the development team, overseeing daily operations and project delivery',
        'Lead the design, development, and maintenance of microservices-based architectures',
        'Develop responsive user interfaces and robust backend services',
        'Work within an agile framework, participating in daily stand-ups and sprint planning',
        'Coordinate with cross-functional teams to translate business requirements',
        'Ensure seamless integration with third-party services'
      ],
      requirements: [
        'Minimum 5 years of fullstack development experience with team leadership',
        'Strong proficiency in frontend technologies (JavaScript, React, Tailwind CSS, TypeScript)',
        'Expertise in backend development using Node.js and microservices architectures',
        'Extensive experience working in agile environments',
        'Proficiency with RESTful APIs, database design, and CI/CD pipelines',
        "Bachelor's degree in Computer Science or equivalent experience"
      ],
      benefits: [
        'Fully remote work environment',
        'Pioneering team driving e-commerce innovation',
        'Collaborative, innovative work environment',
        'Competitive salary and benefits package',
        'Professional development opportunities'
      ]
    },
    'backend-engineer': {
      title: 'Backend Engineer – E-commerce Applications',
      department: 'Engineering',
      location: 'Full Remote',
      about: 'SellAbroad empowers international e-commerce brands to expand into the MENA market by streamlining cross-border logistics, integrating local payment methods, and leveraging AI sales tools. We deliver robust, scalable, and secure e-commerce applications that help our clients achieve global success.',
      description: 'We are looking for a skilled Backend Engineer to join our innovative team. In this role, you will design, develop, and maintain the back-end services that power our e-commerce applications. You will build secure and scalable microservices using Node.js and integrate with e-commerce platforms.',
      responsibilities: [
        'Design, build, and maintain microservices to support platform scalability',
        'Integrate with e-commerce platforms, payment systems, and logistics providers',
        'Ensure backend components are secure and optimized',
        'Work closely with cross-functional teams',
        'Participate in agile development cycles',
        'Troubleshoot and resolve backend issues promptly'
      ],
      requirements: [
        'Minimum 3 years of hands-on experience in backend development with Node.js',
        'Strong understanding of microservice architectures',
        'Experience with e-commerce platforms and payment systems integration',
        'Proficiency with databases (SQL and/or NoSQL)',
        'Experience with agile development practices',
        "Bachelor's degree in Computer Science or equivalent experience"
      ],
      benefits: [
        'Fully remote work environment',
        'Pioneering team driving e-commerce innovation',
        'Collaborative, innovative work environment',
        'Competitive salary and benefits package',
        'Professional development opportunities'
      ]
    },
    'frontend-engineer': {
      title: 'Frontend Engineer – E-commerce Applications',
      department: 'Engineering',
      location: 'Full Remote',
      about: 'SellAbroad empowers international e-commerce brands to expand into the MENA market by streamlining cross-border logistics, integrating local payment methods, and leveraging AI sales tools. We build robust, scalable, and secure e-commerce applications that drive global success.',
      description: 'We are seeking a talented Frontend Engineer to join our innovative team. In this role, you will develop user-friendly interfaces for our e-commerce applications using JavaScript, React, Tailwind CSS, and TypeScript.',
      responsibilities: [
        'Design and implement responsive user interfaces',
        'Collaborate with backend engineers and UX/UI designers',
        'Participate in agile development cycles',
        'Optimize application performance',
        'Stay current with emerging frontend trends'
      ],
      requirements: [
        'Minimum 3 years of hands-on experience in frontend development',
        'Proficiency in JavaScript, React, Tailwind CSS, and TypeScript',
        'Strong understanding of responsive design principles',
        'Experience with RESTful APIs',
        'Familiarity with agile development practices',
        "Bachelor's degree in Computer Science or equivalent experience"
      ],
      benefits: [
        'Fully remote work environment',
        'Pioneering team driving e-commerce innovation',
        'Collaborative, innovative work environment',
        'Competitive salary and benefits package',
        'Professional development opportunities'
      ]
    },
    'uxui-designer': {
      title: 'UX/UI Designer',
      department: 'Design',
      location: 'Remote',
      about: 'SellAbroad is seeking a talented UX/UI Designer...',
      description: 'As a UX/UI Designer at SellAbroad...',
      responsibilities: [
        'Create intuitive user interfaces for our e-commerce platform',
        'Design responsive web and mobile experiences',
        'Develop and maintain design systems',
        'Conduct user research and usability testing',
        'Collaborate with frontend developers to implement designs'
      ],
      requirements: [
        'Expert in Figma and design systems',
        'Strong portfolio of web/mobile projects',
        'Experience with user research',
        'Understanding of frontend development',
        'Experience with design tools and prototyping'
      ],
      benefits: [
        'Competitive salary and equity',
        'Remote work flexibility',
        'Health insurance',
        'Professional development budget',
        'Latest design tools and software'
      ]
    }
  };

  const currentPosition = positionData[position];

  if (!currentPosition) {
    return (
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl font-bold text-gray-900">Position Not Found</h1>
          <p className="mt-4 text-gray-600">The position you're looking for doesn't exist.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        {/* Back to Careers Button */}
        <Link
          to="/careers"
          className="inline-flex items-center mb-8 text-[#0049ac] hover:text-[#0049ac]/80 transition-colors"
        >
          <svg 
            xmlns="http://www.w3.org/2000/svg" 
            className="h-5 w-5 mr-2" 
            viewBox="0 0 20 20" 
            fill="currentColor"
          >
            <path 
              fillRule="evenodd" 
              d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" 
              clipRule="evenodd" 
            />
          </svg>
          Back to Careers
        </Link>

        <div className="bg-white rounded-lg shadow-xl overflow-hidden">
          <div className="p-8">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">{currentPosition.title}</h1>
            <p className="text-gray-500 mb-6">{currentPosition.department} • {currentPosition.location}</p>
            
            <div className="mb-8">
              <h2 className="text-xl font-semibold text-gray-900 mb-4">About SellAbroad:</h2>
              <p className="text-gray-600 mb-6">{currentPosition.about}</p>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">Job Description:</h2>
              <p className="text-gray-600 mb-6">{currentPosition.description}</p>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">Key Responsibilities:</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
                {currentPosition.responsibilities.map((resp, idx) => (
                  <li key={idx}>{resp}</li>
                ))}
              </ul>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">Requirements:</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2 mb-6">
                {currentPosition.requirements.map((req, idx) => (
                  <li key={idx}>{req}</li>
                ))}
              </ul>

              <h2 className="text-xl font-semibold text-gray-900 mb-4">What We Offer:</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                {currentPosition.benefits.map((benefit, idx) => (
                  <li key={idx}>{benefit}</li>
                ))}
              </ul>
            </div>

            <Link
              to={`/careers/${position}/apply`}
              className="inline-flex items-center px-6 py-3 text-base font-medium text-white bg-[#0049ac] rounded-lg hover:bg-[#0049ac]/90 hover:scale-105 transform transition-all duration-300"
            >
              Apply Now
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PositionDetails; 